const discountActions = {
  // Fetch all discounts
  FETCHING_DISCOUNT_BEGIN: "FETCHING_DISCOUNT_BEGIN",
  FETCHING_DISCOUNT_SUCCESS: "FETCHING_DISCOUNT_SUCCESS",
  FETCHING_DISCOUNT_ERR: "FETCHING_DISCOUNT_ERR",

  // Fetch single discount
  FETCHING_SINGLE_DISCOUNT_BEGIN: "FETCHING_SINGLE_DISCOUNT_BEGIN",
  FETCHING_SINGLE_DISCOUNT_SUCCESS: "FETCHING_SINGLE_DISCOUNT_SUCCESS",
  FETCHING_SINGLE_DISCOUNT_ERR: "FETCHING_SINGLE_DISCOUNT_ERR",

  // Add discount
  ADDING_DISCOUNT_BEGIN: "ADDING_DISCOUNT_BEGIN",
  ADDING_DISCOUNT_SUCCESS: "ADDING_DISCOUNT_SUCCESS",
  ADDING_DISCOUNT_ERR: "ADDING_DISCOUNT_ERR",

  // Update discount
  UPDATE_DISCOUNT_BEGIN: "UPDATE_DISCOUNT_BEGIN",
  UPDATE_DISCOUNT_SUCCESS: "UPDATE_DISCOUNT_SUCCESS",
  UPDATE_DISCOUNT_ERR: "UPDATE_DISCOUNT_ERR",

  // Delete discount
  DELETE_DISCOUNT_BEGIN: "DELETE_DISCOUNT_BEGIN",
  DELETE_DISCOUNT_SUCCESS: "DELETE_DISCOUNT_SUCCESS",
  DELETE_DISCOUNT_ERR: "DELETE_DISCOUNT_ERR",

  // Get usage statistics
  FETCHING_DISCOUNT_STATS_BEGIN: "FETCHING_DISCOUNT_STATS_BEGIN",
  FETCHING_DISCOUNT_STATS_SUCCESS: "FETCHING_DISCOUNT_STATS_SUCCESS",
  FETCHING_DISCOUNT_STATS_ERR: "FETCHING_DISCOUNT_STATS_ERR",

  // Validate coupon
  VALIDATE_COUPON_BEGIN: "VALIDATE_COUPON_BEGIN",
  VALIDATE_COUPON_SUCCESS: "VALIDATE_COUPON_SUCCESS",
  VALIDATE_COUPON_ERR: "VALIDATE_COUPON_ERR",

  // Apply coupon
  APPLY_COUPON_BEGIN: "APPLY_COUPON_BEGIN",
  APPLY_COUPON_SUCCESS: "APPLY_COUPON_SUCCESS",
  APPLY_COUPON_ERR: "APPLY_COUPON_ERR",

  fetchingDiscountBegin: () => {
    return {
      type: discountActions.FETCHING_DISCOUNT_BEGIN,
    };
  },

  fetchingDiscountSuccess: (data) => {
    return {
      type: discountActions.FETCHING_DISCOUNT_SUCCESS,
      data,
    };
  },

  fetchingDiscountErr: (err) => {
    return {
      type: discountActions.FETCHING_DISCOUNT_ERR,
      err,
    };
  },

  fetchingSingleDiscountBegin: () => {
    return {
      type: discountActions.FETCHING_SINGLE_DISCOUNT_BEGIN,
    };
  },

  fetchingSingleDiscountSuccess: (data) => {
    return {
      type: discountActions.FETCHING_SINGLE_DISCOUNT_SUCCESS,
      data,
    };
  },

  fetchingSingleDiscountErr: (err) => {
    return {
      type: discountActions.FETCHING_SINGLE_DISCOUNT_ERR,
      err,
    };
  },

  addingDiscountBegin: () => {
    return {
      type: discountActions.ADDING_DISCOUNT_BEGIN,
    };
  },

  addingDiscountSuccess: (data) => {
    return {
      type: discountActions.ADDING_DISCOUNT_SUCCESS,
      data,
    };
  },

  addingDiscountErr: (err) => {
    return {
      type: discountActions.ADDING_DISCOUNT_ERR,
      err,
    };
  },

  updateDiscountBegin: () => {
    return {
      type: discountActions.UPDATE_DISCOUNT_BEGIN,
    };
  },

  updateDiscountSuccess: (data) => {
    return {
      type: discountActions.UPDATE_DISCOUNT_SUCCESS,
      data,
    };
  },

  updateDiscountErr: (err) => {
    return {
      type: discountActions.UPDATE_DISCOUNT_ERR,
      err,
    };
  },

  deleteDiscountBegin: () => {
    return {
      type: discountActions.DELETE_DISCOUNT_BEGIN,
    };
  },

  deleteDiscountSuccess: (id) => {
    return {
      type: discountActions.DELETE_DISCOUNT_SUCCESS,
      id,
    };
  },

  deleteDiscountErr: (err) => {
    return {
      type: discountActions.DELETE_DISCOUNT_ERR,
      err,
    };
  },

  fetchingDiscountStatsBegin: () => {
    return {
      type: discountActions.FETCHING_DISCOUNT_STATS_BEGIN,
    };
  },

  fetchingDiscountStatsSuccess: (data) => {
    return {
      type: discountActions.FETCHING_DISCOUNT_STATS_SUCCESS,
      data,
    };
  },

  fetchingDiscountStatsErr: (err) => {
    return {
      type: discountActions.FETCHING_DISCOUNT_STATS_ERR,
      err,
    };
  },

  validateCouponBegin: () => {
    return {
      type: discountActions.VALIDATE_COUPON_BEGIN,
    };
  },

  validateCouponSuccess: (data) => {
    return {
      type: discountActions.VALIDATE_COUPON_SUCCESS,
      data,
    };
  },

  validateCouponErr: (err) => {
    return {
      type: discountActions.VALIDATE_COUPON_ERR,
      err,
    };
  },

  applyCouponBegin: () => {
    return {
      type: discountActions.APPLY_COUPON_BEGIN,
    };
  },

  applyCouponSuccess: (data) => {
    return {
      type: discountActions.APPLY_COUPON_SUCCESS,
      data,
    };
  },

  applyCouponErr: (err) => {
    return {
      type: discountActions.APPLY_COUPON_ERR,
      err,
    };
  },
};

export default discountActions;
